import { connect } from 'react-redux';
import type { ActionCreator } from 'redux';
import type { OverrideValues, AccommodationState } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchHotels } from '@/ducks/searchResults/actions';
import {
    type SelectedCheckboxDispatchProps,
    SelectedCheckboxFilter,
    type SelectedCheckboxStateProps,
} from '../../../../components/selectedCheckboxFilter/SelectedCheckboxFilter';

const createDisplayValue = (value: number) => (value < 0 ? 'Ingen gjestevurdering' : `Gjestevurdering: ${value}/10`);

const facetList = [-1, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => ({ value: `${value}`, displayValue: createDisplayValue(value) }));

export const mapStateToProps = (state: AccommodationState): SelectedCheckboxStateProps => ({
    id: 'GuestRatingFilter',
    facetList,
    checkboxValues: state.filters.guestRating,
});

export const mapDispatchToProps: OverrideValues<SelectedCheckboxDispatchProps, ActionCreator<unknown>> = {
    checkBoxClick: actions.filterGuestRating,
    triggerFetch: fetchHotels,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedCheckboxFilter);
